import { normalizeIrMobile, toEnglishDigits } from "./phone";

export type SheetPhones = {
  phones: string[]; // valid, normalised (09xxxxxxxxx), de-duplicated
  invalid: { row: number; value: string }[]; // cells that look like a number but are not a mobile
  duplicates: number;
};

/**
 * Read every sheet of an .xlsx/.xls/.csv file in the browser and collect the
 * Iranian mobile numbers in any column. Text cells without digits (headers,
 * names) are ignored; numeric-looking cells that are not a valid mobile are
 * reported with their row number.
 */
export async function readPhonesFromSheet(file: File): Promise<SheetPhones> {
  const XLSX = await import("xlsx"); // separate chunk, loaded only when used
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: "array", raw: false });
  const seen = new Set<string>();
  const result: SheetPhones = { phones: [], invalid: [], duplicates: 0 };

  for (const name of wb.SheetNames) {
    const rows: unknown[][] = XLSX.utils.sheet_to_json(wb.Sheets[name], {
      header: 1,
      raw: true,
      blankrows: false,
      defval: "",
    });
    rows.forEach((row, i) => {
      (row || []).forEach((cell) => {
        if (cell === null || cell === undefined || cell === "") return;
        const text = toEnglishDigits(String(cell)).trim();
        const digits = text.replace(/\D/g, "");
        if (digits.length < 7) return; // header / name / small number
        const phone = normalizeIrMobile(text);
        if (!phone) {
          result.invalid.push({ row: i + 1, value: String(cell) });
          return;
        }
        if (seen.has(phone)) {
          result.duplicates++;
          return;
        }
        seen.add(phone);
        result.phones.push(phone);
      });
    });
  }
  return result;
}
